import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Get root element with type assertion
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    'Root element not found. Make sure there is a <div id="root"></div> in your index.html'
  );
}

// Create root and render app with StrictMode for development checks
createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
